import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import styles from "@/components/filters/v2/BadgeManager.module.css";
import FilterBadgeComponent from "@/components/ui/buttons/FilterBadgeComponent";

// Display names for filters
const filterDisplayNames = {
  make: 'Make',
  model: 'Model',
  range: 'Range',
  body_style: 'Body Style',
  seats: 'Seats',
  price: 'Price'
};

// Utility function to get the display name of a filter
function getFilterDisplayName(filter) {
  return filterDisplayNames[filter] || filter;
}

function transformFilterValue(filter, value) {
  if (filter === 'price') {
    const range = value.split('-');
    if (range.length === 2) {
      const start = '£'.repeat(Number(range[0]) + 1);  // Adding 1 because you start from 0
      const end = '£'.repeat(Number(range[1]) + 1);
      return `${start}-${end}`;
    }
  } else if (filter === 'range') {
    return `${value} mi`;
  }
  return value;
}


const BadgeManager = ({onBadgeRemove, filters}) => {
  const [badgeState, setBadgeState] = useState([]);
  const router = useRouter();

  useEffect(() => {
    const newBadges = filters.reduce((result, filter) => {
      const value = router.query[filter];
      if (value && typeof value === 'string') {

        const transformedValue = transformFilterValue(filter, value);
        return [...result, {filterIndex: filter, text: `${getFilterDisplayName(filter)}: ${transformedValue}`}];

      }
      return result;
    }, []);

    setBadgeState(prevState => [
      ...prevState.filter(
        badge => !filters.includes(badge.filterIndex)
      ),
      ...newBadges
    ]);
  }, [router.query, filters]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.filterCount}>Filters [{badgeState.length}]</div>
        <div className={styles.divider}>|</div>
        <div className={styles.clearAllButton}>
          Clear All
        </div>
      </div>
      {badgeState.length > 0 && (
        <div className={styles.filtersBadges}>
          {badgeState.map(badge => (
            <FilterBadgeComponent
              key={badge.filterIndex}
              text={badge.text}
              onRemove={() => onBadgeRemove(badge.filterIndex)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BadgeManager;
